export default () => {
    document.addEventListener('DOMContentLoaded', () => {
        const leaveLink = document.querySelectorAll('[data-popup="true"]');
        if (leaveLink.length > 0) {
            leaveLink.forEach((element) => {
                element.addEventListener('click', (e) => {
                    e.preventDefault();
                    // reset
                    document.getElementById('leavePageModalOverrideText').innerHTML = '';
                    document.getElementById('leavePageModalText').style = 'display: block';
                    document.getElementById('leavePageModalOverrideText').style = 'display: block';
                    if (element.dataset.popuptext !== '' && element.dataset.popuptext !== undefined) {
                        document.getElementById('leavePageModalText').style = 'display: none';
                        document.getElementById('leavePageModalOverrideText').style = 'display: block';
                        document.getElementById('leavePageModalOverrideText').innerHTML = element.dataset.popuptext;
                    }
                    document.getElementById('leavePageModalLink').href = element.href;
                    const leavePageModal = new bootstrap.Modal(document.getElementById('leavePageModal'));
                    leavePageModal.show();
                });
            });
        }
    });
};
